export const INTEREST_SOURCE = {
    goread: 1,
    gowrite: 2
}
